import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MixpanelAnalytics } from '../analytics';

export function usePageTracking(enabled = true): void {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;

    MixpanelAnalytics.pageViewed({
      page_path: location.pathname,
      page_search: location.search || undefined,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
    });
  }, [location.pathname, location.search, enabled]);
}
